<template>
  <account-modal class="delete-account-number-modal">
    <template slot="heading">Delete IBAN {{ accountNumber }} ({{ channel | channel }})?</template>

    <template slot="content">
      <v-text-field
        v-model="form.reason"
        max-length="1000"
        label="Reason for IBAN deletion"
        placeholder="Please, provide reason why you’re deleting this IBAN"
        hint="Required field"
        persistent-hint
        :error-messages="getValidationErrorMessage('reason')"
      />

      <error-alert :error="error" />
    </template>

    <template slot="actions">
      <v-btn
        class="t-delete-button"
        color="light-blue darken-3"
        flat
        :disabled="!isFormFilled || loading"
        @click="onDeleteButtonClick"
      >delete</v-btn>

      <v-btn
        color="light-blue darken-3"
        flat
        @click="onCancelButtonClick"
      >cancel</v-btn>
    </template>
  </account-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Events
  import { EVENT_ACCOUNT_UPDATE } from '@/events/accounts'
  import { EVENT_PROFILE_CUSTOMER_UPDATE } from '@/events/profileCustomers'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import AccountApi from '@/services/Api/AccountApi'

  // Mixins
  import form from '@/mixins/form'

  // Component
  import AccountModal from '@/components/accounts/AccountModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'DeleteAccountNumberModal',
    components: {
      AccountModal,
      ErrorAlert
    },
    mixins: [form],
    data () {
      return {
        accountNumberDeleteApiRequest: new ApiRequest(AccountApi.deleteAccountNumber),
        form: { reason: null },
        requiredFields: ['reason']
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      accountId () {
        return this.modal.data.accountId
      },
      accountNumber () {
        return this.modal.data.accountNumber
      },
      channel () {
        return this.modal.data.channel
      },
      loading () {
        return this.accountNumberDeleteApiRequest.loading
      },
      error () {
        return this.accountNumberDeleteApiRequest.error
      },
      profileId () {
        return this.modal.data.profileId || null
      }
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onDeleteButtonClick () {
        this.deleteAccountNumber()
          .then(() => {
            if (this.profileId) {
              this.$eventHub.$emit(EVENT_ACCOUNT_UPDATE, this.profileId)
            }
            this.$eventHub.$emit(EVENT_PROFILE_CUSTOMER_UPDATE)
            this.closeModal()

            setTimeout(() => {
              this.showModal({
                name: 'SuccessFlashModal',
                data: { message: 'IBAN has been successfully deleted.' }
              })
            }, 100)
          })
          .catch(() => {})
      },
      onCancelButtonClick () {
        this.closeModal()
      },
      deleteAccountNumber () {
        return this.accountNumberDeleteApiRequest.execute(this.accountId, {
          accountNumber: this.accountNumber,
          reason: this.form.reason,
          channel: this.channel
        })
      }
    }
  }
</script>
